import React, { useEffect, useState } from "react";
import { useParams, useNavigate } from "react-router-dom";
import { RUTAS_INCIDENCIAS } from "../Rutas";
import LayoutGeneral from "../LayoutGeneral";
import "./Incidencia_Seguimiento.css";
import Select from "react-select";
import DatePicker from "react-datepicker";

const Incidencia_Seguimiento = () => {
    const navigate = useNavigate();
    const idUsuario = localStorage.getItem('idUsuario');
    // Campo proveniente de la URL
    const { idIncidencia } = useParams();
    const [incidencia, setIncidencia] = useState(null);
    const [acuerdos, setAcuerdos] = useState([]);
    const EsAdmin = localStorage.getItem("admin");
    const roles = JSON.parse(localStorage.getItem('roles') || '[]');
    const rolUsuario = roles.length > 0 ? roles[0].idRol : null;
    const puedeVerReporte = roles.some(role => role.idRol === 1 || role.idRol === 2 || role.idRol === 3);
    // Tipo Incidencia
    const [tipoIncidencia, setTipoIncidencia] = useState([]);
    const [tipoIncidenciaSeleccionada, settipoIncidenciaSeleccionada] = useState("")
    //Fecha de incidencia
    const [fechaInicioIncidencia, setFechaInicioIncidencia] = useState(null);
    const [fechaFinIncidencia, setFechaFinIncidencia] = useState(null);
    //Estatus de incidencia
    const [estatusIncidencia, setEstatusIncidencia] = useState(null);
    // Modal / reapertura states
    const [showReapModal, setShowReapModal] = useState(false);
    const [reapComentario, setReapComentario] = useState("");
    const [pendingReap, setPendingReap] = useState(null); // { idx, idAcuerdoBitacora, idBitacora, idAcuerdo, comentario }

    // Estados para paneles retractibles
    const [expandedPanels, setExpandedPanels] = useState({
        principales: true,
        contacto: true,
        estatus: true,
        comentarios: true
    });

    const togglePanel = (panelName) => {
        setExpandedPanels(prev => ({
            ...prev,
            [panelName]: !prev[panelName]
        }));
    };
    const convertirFecha = (fecha) => {
        if (!fecha) return null;

        // Recibimos: "27/10/2026 12:00:00 a. m."
        const fechaParte = fecha.split(" ")[0];

        // Resultado: "27/10/2026"
        const [dia, mes, anio] = fechaParte.split("/");

        return new Date(
            parseInt(anio),
            parseInt(mes) - 1,
            parseInt(dia)
        );
    };
    const formatearFecha = (fecha) => {
    if (!fecha) return "";

    const anio = fecha.getFullYear();
    const mes = String(fecha.getMonth() + 1).padStart(2, "0");
    const dia = String(fecha.getDate()).padStart(2, "0");

    return `${dia}/${mes}/${anio}`;
};

    useEffect(() => {
        const fetchTipoIncidencia = async () => {
            try {
                const res = await fetch(RUTAS_INCIDENCIAS.GET_TIPO_INCIDENCIA);
                const data = await res.json();
                console.log(data);
                setTipoIncidencia(data);
            } catch (error) {
                console.error("Error cargando roles:", error);
            }
        };
        fetchTipoIncidencia();
        const fetchIncidencia = async () => {
            try {
                const res = await fetch(RUTAS_INCIDENCIAS.GET_INCIDENCIAID(idIncidencia));
                const data = await res.json();
                setIncidencia(data);
                // setAcuerdos(data.acuerdos || []);
                console.log("Incidencia cargada:", data, idIncidencia);
                // Tipo de incidencia
                settipoIncidenciaSeleccionada(
                    data.idTipoIncidencia?.toString() || ""
                );
                // Fechas - DatePicker necesita objetos Date
                setFechaInicioIncidencia(
                    data.fechaInicio ? convertirFecha(data.fechaInicio) : null
                );

                setFechaFinIncidencia(
                    data.fechaFin ? convertirFecha(data.fechaFin) : null
                );
                setEstatusIncidencia(data.estatus);

            } catch (error) {
                console.error("Error al cargar la incidencia:", error);
            }
        };
        fetchIncidencia();
    }, [idIncidencia]);

    const actualizarIncidencia= async (e) => {
        e.preventDefault();

        // if (!validateForm()) {
        //     alert("Completa todos los campos obligatorios.");
        //     return;
        // }
        //const fechaFormateada = fechaActividad ? `${fechaActividad.getFullYear()}-${String(fechaActividad.getMonth()+1).padStart(2,'0')}-${String(fechaActividad.getDate()).padStart(2,'0')} ${horaContacto}` : "";
        const fechaSistema = new Date().toISOString();
        const modelo = {
          IdIncidencia:idIncidencia,
          idUsuario: Number(idUsuario),
          idTipoIncidencia: tipoIncidenciaSeleccionada ? Number(tipoIncidenciaSeleccionada) : 0,
          tipoIncidencia:"",
          fechaInicio:  formatearFecha(fechaInicioIncidencia),
          fechaFin:  formatearFecha(fechaFinIncidencia),         
          estatus: estatusIncidencia ? 1 : 0,
          fechaCreacion: fechaSistema,  
          usuarioCreador: 0,
          Nombre:""
        };
        try {
            console.log("MODELO:", modelo);
console.log("JSON:", JSON.stringify(modelo));
          const res = await fetch(RUTAS_INCIDENCIAS.UPDATE_INCIDENCIA, {
            method: "POST",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify(modelo)
          });
    
          if (res.ok) {
            alert("Incidencia guardada correctamente.");
            navigate("/Incidencias");
          } else {
            const error = await res.text();
            alert("Error al guardar la incidencia: " + error);
          }
        } catch (error) {
          alert("Error de conexión: " + error.message);
        }
    };
    // Envia actualización al backend
    //   const enviarActualizacionAcuerdo = async (idx, idAcuerdoBitacora, idBitacoraParam, idAcuerdo, comentario, nuevoEstatus, comentarioReapertura) => {
    //     const modelo = {
    //       idAcuerdoBitacora,
    //       idBitacora: idBitacoraParam,
    //       idAcuerdo,
    //       descripcion: "",
    //       comentario: comentario || "",
    //       estatus: nuevoEstatus,
    //       comentarioReapertura: comentarioReapertura || "",
    //       fechaCompromiso: "" // No se actualiza esta parte, se mantiene igual en el backend
    //     };

    //     try {
    //       const res = await fetch(RUTAS_INCIDENCIAS.UPDATE_ACUERDO_BITACORA, {
    //         method: "POST",
    //         headers: { "Content-Type": "application/json" },
    //         body: JSON.stringify(modelo)
    //       });

    //       const data = await res.json().catch(() => ({}));
    //       if (res.ok) {
    //         // Actualiza estado local
    //         const updated = acuerdos.map((a, i) =>
    //           i === idx ? { ...a, estatus: modelo.estatus } : a
    //         );
    //         setAcuerdos(updated);
    //         alert(data.message || "Estatus actualizado correctamente.");
    //       } else {
    //         alert(data.message || "Error al actualizar el estatus del acuerdo.");
    //       }
    //     } catch (error) {
    //       alert("Error de conexión al actualizar el acuerdo.");
    //       console.error(error);
    //     } finally {
    //       // limpiar pending si existía
    //       setPendingReap(null);
    //       setShowReapModal(false);
    //     }
    //   };

    if (!incidencia) return <div className="container mt-4">Cargando...</div>;

    //   // Separar fecha y hora de contacto
    //   const fechaContactoParts = bitacora.fechaContacto ? bitacora.fechaContacto.split(' ') : ['', ''];
    //   const fechaContacto = fechaContactoParts[0];
    //   const horaContacto = fechaContactoParts[1];

    //   const fechaCreacion =  bitacora.fechaCreacion;

    //   const obtenerTipoContacto = () => {
    //     if (Number(bitacora?.tipoInt) === 2) return "Agente";
    //     if (Number(bitacora?.tipoInt) === 1) return "Promotor";
    //     return bitacora?.tipoInt || "N/A";
    //   };

    return (
        <LayoutGeneral titulo="Incidencia_Seguimiento">
            <div className="home-container">
                <aside className="sidebar">
                    <ul>
                        <li onClick={() => navigate("/Home")}><i className="bi bi-house"></i> Inicio</li>
                        {EsAdmin == 1 && (
                                <li onClick={() => navigate("/Usuarios")}><i className="bi bi-people"></i> Usuarios</li>
                        )}
                         {puedeVerReporte && (
                                <li onClick={() => navigate("/Incidencias")}><i className="bi bi-people"></i> Incidencias</li>
                        )}
                        <li onClick={() => navigate("/Bitacoras")}><i className="bi bi-journal"></i> Bitácoras</li>
                        <li className="logout" onClick={() => { localStorage.clear(); navigate("/"); }}>
                            <i className="bi bi-box-arrow-right"></i> Cerrar Sesión
                        </li>
                    </ul>
                </aside>
                <main className="main-content">
                    <h2>
                        <button className="btn btn-primary mt-3" onClick={() => navigate("/Incidencias")}>
                            Regresar
                        </button>
                        <center> <span>Seguimiento de la Incidencia {incidencia.idIncidencia} </span> </center>
                    </h2>
                    <div className="row mb-3" id="EncabezadoBitacora">
                        <div className="col-md-12">

                            {/* Panel 1: Datos Principales */}
                            <div className="card mb-2">
                                <div
                                    className="card-header d-flex align-items-center justify-content-between cursor-pointer"
                                    onClick={() => togglePanel('principales')}
                                    style={{ cursor: 'pointer', backgroundColor: '#b2d3f5' }}
                                >
                                    <strong>Datos Principales</strong>
                                    <i className={`bi bi-chevron-${expandedPanels.principales ? 'down' : 'right'}`} />
                                </div>
                                {expandedPanels.principales && (
                                      <form className="nueva-Bitacora-form" onSubmit={actualizarIncidencia}>
                                    <div className="card-body">
                                        <div className="row mb-2">
                                            <div className="col-md-6"><strong>Nombre:</strong> {incidencia.nombre}</div>
                                            <div className="col-md-6"><strong>Tipo Incidencia:</strong>
                                                <select
                                                class="form-control"
                                                    value={tipoIncidenciaSeleccionada || ""}
                                                    onChange={(e) =>
                                                        settipoIncidenciaSeleccionada(e.target.value)
                                                    }
                                                >
                                                    <option value="">
                                                        Seleccione un tipo de incidencia
                                                    </option>

                                                    {tipoIncidencia.map((item) => (
                                                        <option
                                                            key={item.idIncidencia}
                                                            value={item.idIncidencia}
                                                        >
                                                            {item.incidencia}
                                                        </option>
                                                    ))}
                                                </select>
                                            </div>
                                            <div className="col-md-6" >
                                                <label htmlFor="fechaInicio" className="form-label">Fecha Inicio</label>
                                                <DatePicker
                                                selected={fechaInicioIncidencia}
                                                onChange={(date) => setFechaInicioIncidencia(date)}
                                                className="form-control"
                                                dateFormat="dd/MM/yyyy"
                                                placeholderText="Selecciona una fecha"
                                                showYearDropdown
                                                scrollableYearDropdown
                                                yearDropdownItemNumber={30}
                                            /></div>
                                            <div className="col-md-4"><label htmlFor="fechaInicio" className="form-label">Fecha Fin</label><DatePicker
                                                selected={fechaFinIncidencia}
                                                onChange={(date) => setFechaFinIncidencia(date)}
                                                className="form-control w-100"
                                                dateFormat="dd/MM/yyyy"
                                                placeholderText="Selecciona una fecha"
                                                showYearDropdown
                                                scrollableYearDropdown
                                                yearDropdownItemNumber={30}
                                            /></div>
                                            <div className="col-md-4">
                                                <label className="form-label">Estatus</label>
                                                <div className="form-check form-switch">
                                                    <input
                                                        className="form-check-input"
                                                        type="checkbox"
                                                        id="estatusIncidencia"
                                                        onChange={(e) => setEstatusIncidencia(e.target.checked)}
                                                        checked={estatusIncidencia}
                                                    // onChange={() => toggleEstatusAcuerdo(idx, a.idAcuerdoBitacora, a.idBitacora, a.idAcuerdo, a.comentario)}
                                                    />
                                                    <label
                                                        className="form-check-label"
                                                        htmlFor="estatusIncidencia"
                                                    >
                                                        {estatusIncidencia ? "Aprobado" : "Cancelado"}
                                                    </label>
                                                </div>
                                            </div>
                                        </div>
                                        {/* Botón de Guardar Incidencia */}
                                        <div className="d-flex justify-content-center">
                                            <button type="submit" className="btn btn-primary">
                                                Guardar Cambios
                                            </button>
                                        </div>
                                    </div>
                                    </form>
                                )}
                            </div>


                        </div>
                    </div>

                </main>
            </div>
        </LayoutGeneral>
    );
};

export default Incidencia_Seguimiento;